// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IBalanceAdjustmentRequestDto
 */
export interface IBalanceAdjustmentRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IBalanceAdjustmentRequestDto
     */
    balance_adjustment_request_id: string;
    /**
     * 
     * @type {string}
     * @memberof IBalanceAdjustmentRequestDto
     */
    external_employer_id: string;
    /**
     * 
     * @type {number}
     * @memberof IBalanceAdjustmentRequestDto
     */
    employee_id: number;
    /**
     * 
     * @type {string}
     * @memberof IBalanceAdjustmentRequestDto
     */
    destination_plan_code: string;
    /**
     * 
     * @type {string}
     * @memberof IBalanceAdjustmentRequestDto
     */
    transaction_type: IBalanceAdjustmentRequestDtoTransactionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IBalanceAdjustmentRequestDto
     */
    transaction_amount: number;
    /**
     * 
     * @type {string}
     * @memberof IBalanceAdjustmentRequestDto
     */
    memo?: string;
    /**
     * 
     * @type {string}
     * @memberof IBalanceAdjustmentRequestDto
     */
    source_plan_code?: string;
    /**
     * 
     * @type {string}
     * @memberof IBalanceAdjustmentRequestDto
     */
    pay_by?: IBalanceAdjustmentRequestDtoPayByEnum;
}

/**
* @export
* @enum {string}
*/
export enum IBalanceAdjustmentRequestDtoTransactionTypeEnum {
    ADJUSTMENT = 'ADJUSTMENT',
    CLAIM_BALANCE_ADJUSTMENT = 'CLAIM_BALANCE_ADJUSTMENT',
    ROLLOVER_BALANCE_ADJUSTMENT = 'ROLLOVER_BALANCE_ADJUSTMENT'
}
/**
* @export
* @enum {string}
*/
export enum IBalanceAdjustmentRequestDtoPayByEnum {
    PARTNER = 'PARTNER',
    DISTRIBUTOR = 'DISTRIBUTOR',
    EMPLOYER = 'EMPLOYER',
    SUBSIDIARY = 'SUBSIDIARY',
    PLAN = 'PLAN'
}


/**
 * Check if a given object implements the IBalanceAdjustmentRequestDto interface.
 */
export function instanceOfIBalanceAdjustmentRequestDto(value: object): value is IBalanceAdjustmentRequestDto {
    if (!('balance_adjustment_request_id' in value) || value['balance_adjustment_request_id'] === undefined) return false;
    if (!('external_employer_id' in value) || value['external_employer_id'] === undefined) return false;
    if (!('employee_id' in value) || value['employee_id'] === undefined) return false;
    if (!('destination_plan_code' in value) || value['destination_plan_code'] === undefined) return false;
    if (!('transaction_type' in value) || value['transaction_type'] === undefined) return false;
    if (!('transaction_amount' in value) || value['transaction_amount'] === undefined) return false;
    return true;
}

export function IBalanceAdjustmentRequestDtoFromJSON(json: any): IBalanceAdjustmentRequestDto {
    return IBalanceAdjustmentRequestDtoFromJSONTyped(json, false);
}

export function IBalanceAdjustmentRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IBalanceAdjustmentRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'balance_adjustment_request_id': json['balance_adjustment_request_id'],
        'external_employer_id': json['external_employer_id'],
        'employee_id': json['employee_id'],
        'destination_plan_code': json['destination_plan_code'],
        'transaction_type': json['transaction_type'],
        'transaction_amount': json['transaction_amount'],
        'memo': json['memo'] == null ? undefined : json['memo'],
        'source_plan_code': json['source_plan_code'] == null ? undefined : json['source_plan_code'],
        'pay_by': json['pay_by'] == null ? undefined : json['pay_by'],
    };
}

export function IBalanceAdjustmentRequestDtoToJSON(json: any): IBalanceAdjustmentRequestDto {
    return IBalanceAdjustmentRequestDtoToJSONTyped(json, false);
}

export function IBalanceAdjustmentRequestDtoToJSONTyped(value?: IBalanceAdjustmentRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'balance_adjustment_request_id': value['balance_adjustment_request_id'],
        'external_employer_id': value['external_employer_id'],
        'employee_id': value['employee_id'],
        'destination_plan_code': value['destination_plan_code'],
        'transaction_type': value['transaction_type'],
        'transaction_amount': value['transaction_amount'],
        'memo': value['memo'],
        'source_plan_code': value['source_plan_code'],
        'pay_by': value['pay_by'],
    };
}

